import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useMediaQuery } from "@mui/material";
import line_vector from "../assets/line3-vector.svg";
import arrow_new from "../assets/Arrow_service.svg";
import initializeAOS from "../utils/aosLibrary";
import EnouthTalk from "../Components/EnouthTalk";
import arrowdrop from "../assets/down-arrow.png";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";
import baseUrl from "../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from 'react-google-recaptcha';



function GetQuote() {
  const [value, setValue] = useState(0);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [Interested, setInterested] = useState("");
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();
  const { t } = useTranslation();
  const notify = (message) => toast.success(message);
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size <= 20 * 1024 * 1024) {
        // 20MB size limit
        // alert(`File ${selectedFile.name} selected`);
        setFile(selectedFile); // Save file to state
      } else {
        alert("File size exceeds 20MB. Please select a smaller file.");
      }
    }
  };
  const handleSliderChange = (event) => {
    setValue(event.target.value);
  };

  const [captcha, setCaptcha] = useState(null);

  const handlesubmit = async (e) => {
    if (!captcha) {
      alert("Please verify that you are not a robot.");
      return;
    }
    e.preventDefault();
    setLoading(true);
    const formdata = new FormData();
    formdata.append("full_name", fullName);
    formdata.append("email", email);
    formdata.append("phone", phoneNumber);
    formdata.append("interested_in", Interested);
    formdata.append("descriptions", message);
    formdata.append("project_file", file);
    formdata.append("project_budget", value);

    try {
      const response = await axios.post(
        `${baseUrl}/quote_request.php`,
        formdata
      );
      if (response.data.success === true) {
        setLoading(false);
        notify("Your Quote has been submitted successfully");
        setTimeout(() => {
          navigate("/");
        }, 2500);
      }
    } catch (err) {
      console.log({ error: err });
    }
  };

  const fontLivic = "Livvic , sans-serif";
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  useEffect(() => {
    initializeAOS();
  }, []);
  return (
    <>
      <Navbar />
      <div
        style={{
          height: "300px",
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div data-aos="fade-up">
          <h1
            style={{
              fontSize: isXs ? "64px" : "50px",
              lineHeight: "1.15",
              letterSpacing: "0.67px",
              fontWeight: "bold",
              fontWeight: "700",
              textAlign: isXs ? "" : "center",
            }}
          >
            {t('getAQuote.title')}
          </h1>
        </div>
        <img
          src={arrow_new}
          loading="lazy"
          alt="Hero Shape Image"
          className="hero-shape-2"
          style={{
            display: isXs ? "flex" : "none",
            animation: "moveUpDown 1.5s infinite alternate",
            position: "absolute",
            top: "180px",
            left: "87px",
            zIndex: "5",
          }}
        />
        <img
          style={{
            display: isXs ? "flex" : "none",
            position: "absolute",
            right: "0",
            top: "200px",
          }}
          src={line_vector}
          alt=""
        />
      </div>

      <form onSubmit={handlesubmit}>
        <div style={{ height: "auto", width: "100%", padding: "50px 5%" }}>
          <div
            style={{
              height: "100%",
              borderRadius: "50px",
              textAlign: "center",
            }}
          >
            <h1 style={{ padding: "50px 0px 30px 0px", fontFamily: fontLivic }}>
              {t('getAQuote.subtitle')}
            </h1>
            <div
              data-aos="fade-up"
              data-aos-duration="1000"
              style={{
                display: "flex",
                flexDirection: "column",
                padding: isXs ? "20px 40px" : "20px 30px",
                gap: "30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "30px",
                  flexDirection: isXs ? "row" : "column",
                }}
              >
                <input
                  onChange={(e) => setFullName(e.target.value)}
                  style={{
                    borderRadius: "10px",
                    width: "100%",
                    fontFamily: fontLivic,
                    height: "55px",
                    paddingLeft: "20px",
                    border: "1px solid black",
                  }}
                  type="text"
                  placeholder={t('getAQuote.formFields.name')}
                />
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    borderRadius: "10px",
                    width: "100%",
                    fontFamily: fontLivic,
                    height: "55px",
                    paddingLeft: "20px",
                    border: "1px solid black",
                  }}
                  type="email"
                  placeholder={t('getAQuote.formFields.email')}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "30px",
                  flexDirection: isXs ? "row" : "column",
                }}
              >
                <input
                  // oninput="this.value = this.value.replace(/[^0-9\-]+/g, '').replace(/(\..*)\./g, '$1');"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  style={{
                    borderRadius: "10px",
                    width: "100%",
                    fontFamily: fontLivic,
                    height: "55px",
                    paddingLeft: "20px",
                    border: "1px solid black",
                  }}
                  onInput={(e) =>
                  (e.target.value = e.target.value
                    .replace(/[^0-9+]/g, "")
                    .replace(/(?!^)\+/g, ""))
                  }
                  maxLength={15}
                  type="text"
                  placeholder={t('getAQuote.formFields.phone')}
                />
                <select
                  onChange={(e) => setInterested(e.target.value)}
                  value={Interested}
                  id="selectInput"
                  name="selectInputName"
                  style={{
                    borderRadius: "10px",
                    width: "100%",
                    fontFamily: fontLivic,
                    height: "55px",
                    paddingLeft: "10px",
                    border: "1px solid black",
                    color: "#838383",
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    background: `url(${arrowdrop}) no-repeat`,
                    backgroundPosition: "right 10px center",
                    backgroundSize: "20px",
                  }}
                >
                  <option value="Interested in">{t('getAQuote.formFields.dropdown', { returnObjects: true })[0]}</option>
                  <option value="Enterprise Software Solutions">
                    {t('getAQuote.formFields.dropdown', { returnObjects: true })[1]}
                  </option>
                  <option value="Web Development">{t('getAQuote.formFields.dropdown', { returnObjects: true })[2]}</option>
                  <option value="Creating a Mobile App">
                    {t('getAQuote.formFields.dropdown', { returnObjects: true })[3]}
                  </option>
                  <option value="IT Consulting Services">
                    {t('getAQuote.formFields.dropdown', { returnObjects: true })[4]}
                  </option>
                  <option value="Dedicated Team Service">
                    {t('getAQuote.formFields.dropdown', { returnObjects: true })[5]}
                  </option>
                </select>
              </div>
              <textarea
                onChange={(e) => setMessage(e.target.value)}
                style={{
                  borderRadius: "10px",
                  fontFamily: fontLivic,
                  paddingLeft: "20px",
                  paddingTop: "25px",
                  height: "250px",
                  border: "1px solid black",
                }}
                type="text"
                placeholder={t('getAQuote.formFields.textarea')}
              />

              <div
                style={{
                  display: "flex",
                  flexDirection: isXs ? "row" : "column",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px dashed",
                    borderRadius: "10px",
                    padding: "10px 30px",
                    gap: isXs ? "30px" : "0px",
                    width: "100%",
                    flexDirection: isXs ? "" : "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "start",
                    }}
                  >
                    <div style={{ fontSize: "16px", fontWeight: "600" }}>
                      {t('getAQuote.fileUpload.label')}
                    </div>
                    <div>{t('getAQuote.fileUpload.label_1')}</div>
                  </div>
                  <input
                    type="file"
                    accept=""
                    style={{ display: "none" }}
                    id="file-upload"
                    onChange={handleFileChange}
                  />
                  <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                    <div
                      style={{
                        backgroundColor: "gray",
                        padding: isXs ? "10px 20px" : "5px 10px",
                        cursor: "pointer",
                        borderRadius: "10px",
                        color: "white",
                      }}
                    >
                      {" "}
                      📁 {t('getAQuote.fileUpload.attachmentNote')}
                    </div>
                  </label>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    marginTop: isXs ? "30px" : "100px",
                    padding: "0px 40px",
                    // border: "1px solid red",
                  }}
                  className="container"
                >
                  <div
                    className="slider-container"
                    style={{ position: "relative", alignItems: "center" }}
                  >
                    <input
                      type="range"
                      className="form-range"
                      min="0"
                      max="5000"
                      value={value}
                      onChange={handleSliderChange}
                      id="rangeSlider"
                    />
                    <div
                      className="slider-value"
                      style={{
                        display: "flex",
                        gap: "0px",
                        justifyContent: "end",
                        position: "absolute",
                        textAlign: "center",
                        top: "-30px",
                        width: "300px",
                        left: isXs ? "40%" : "0%",
                        transform: "translateX(-50%)",
                        fontWeight: "bold",
                      }}
                    >
                      <div style={{ minWidth: "130px", width: "fit-content", maxWidth: "300px" }}>{t('getAQuote.fileUpload.budget')} :</div>
                      <div>${value}</div>
                    </div>
                  </div>
                </div>

                <style jsx>{`
                  /* Custom range slider styles */
                  #rangeSlider {
                    -webkit-appearance: none;
                    width: 100%;
                    height: 8px;
                    background-color: #000; /* Slider color */
                    border-radius: 5px;
                    outline: none;
                  }

                  #rangeSlider::-webkit-slider-runnable-track {
                    width: 100%;
                    height: 8px;
                    background-color: #000; /* Slider track color */
                  }

                  #rangeSlider::-webkit-slider-thumb {
                    -webkit-appearance: none;
                    appearance: none;
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    background-color: #fff; /* Thumb color */
                    border: 2px solid #000; /* Thumb border color */
                  }

                  #rangeSlider::-moz-range-track {
                    width: 100%;
                    height: 8px;
                    background-color: #000; /* Slider track color */
                  }

                  #rangeSlider::-moz-range-thumb {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    background-color: #fff; /* Thumb color */
                    border: 2px solid #000; /* Thumb border color */
                  }
                `}</style>
              </div>

                             <ReCAPTCHA 
                              sitekey='6LdtsDYrAAAAAPHA1PgP-7vS5rHUHaR_zTCK-WvQ'
                              onChange={(value) => setCaptcha(value)}
                            /> 

              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  marginTop: "20px",
                }}
              >
                <button
                  type="submit"
                  style={{
                    backgroundColor: "#512CEB",
                    color: "white",
                    fontSize: "18px",
                    fontWeight: "600",
                    borderRadius: "10px",
                    width: "300px",
                    border: "none",
                    padding: "10px 20px",
                    textAlign: "center",
                    boxShadow: "5px 10px 18px rgba(0, 0, 0, 0.2)",
                    fontFamily: fontLivic,
                  }}
                >
                  {loading ? (
                    <Loader />
                  ) : (
                    <span>
                      {t('getAQuote.button')}&nbsp;&nbsp;&nbsp;<SendIcon style={{ fontSize: "15px" }} />
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <EnouthTalk />
      <Footer />
      <ToastContainer
        position="top-right" // You can change the position
        autoClose={2000} // You can change the auto close time
        padding="15px"
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>

  );
}

export default GetQuote;
